import * as React from 'react';

import type {FormattedValue} from 'nutshell-core/types';

import {TruncatedItems} from './truncated-items';

type ProductType = {
    name: string;
    amount: FormattedValue;
    quantity: FormattedValue;
};

type Props = {
    value: ProductType[];
};

export function Product(props: Props) {
    const getProductText = (product: ProductType) => {
        const {name, amount, quantity} = product;

        return `${name} (${amount.prefix}${amount.formatted}${amount.suffix}) ${
            quantity.value > 1 ? `x${quantity.formatted}${quantity.suffix}` : ''
        }`;
    };

    return (
        // @ts-expect-error
        <TruncatedItems
            value={props.value}
            renderRow={(product: ProductType) => {
                return (
                    <span title={getProductText(product)} key={product.name}>
                        {getProductText(product)}
                    </span>
                );
            }}
        />
    );
}
